import { Link } from "react-router-dom";

const affiliateUrl = "https://hb.afl.rakuten.co.jp/hsc/57e07128.1f812976.57e07129.192400c1/?link_type=hybrid_url&rafst=rmn&ut=eyJwYWdlIjoic2hvcCIsInR5cGUiOiJoeWJyaWRfdXJsIiwiY29sIjoxLCJjYXQiOjEsImJhbiI6MjM3Nzg5MiwiYW1wIjpmYWxzZX0%3D";
const productUrl = "https://network.mobile.rakuten.co.jp/product/iphone/iphone-17e/";
const campaignUrl = "https://network.mobile.rakuten.co.jp/campaign/iphone-discount/";

function Table({ caption, headers, rows }: { caption: string; headers: string[]; rows: string[][] }) {
  return <div className="not-prose my-7 overflow-x-auto border-y-2 border-foreground-900 bg-white">
    <table className="w-full min-w-[620px] border-collapse text-left text-sm">
      <caption className="p-3 text-left font-bold">{caption}</caption>
      <thead className="bg-background-100"><tr>{headers.map(h => <th key={h} scope="col" className="p-3">{h}</th>)}</tr></thead>
      <tbody>{rows.map(row => <tr key={row[0]} className="border-t border-background-300">{row.map((cell, i) => i === 0 ? <th key={i} scope="row" className="p-3 font-bold">{cell}</th> : <td key={i} className="p-3 leading-6">{cell}</td>)}</tr>)}</tbody>
    </table>
  </div>;
}

export default function RakutenIphone17eArticle() {
  return <>
    <section id="monthly">
      <h2>毎月いくら払う？</h2>
      <p>まず、他社から番号そのままで乗り換え、対象プランとiPhone 17e 256GBを同時に申し込む場合です。楽天カードの48回払いを選び、キャンペーンが適用されると、<strong>端末代は1〜24回目が月1円</strong>になります。</p>
      <Table caption="MNPキャンペーン適用時の毎月の支払い（税込・通信料は割引前）" headers={["毎月のデータ使用量", "端末代（1〜24回目）", "通信料", "毎月の合計"]} rows={[
        ["3GBまで", "1円", "1,078円", "1,079円"],
        ["3GB超〜20GBまで", "1円", "2,178円", "2,179円"],
        ["20GB超", "1円", "3,278円", "3,279円"],
      ]} />
      <p><strong>月1円は端末代の最初の24回だけ</strong>です。返却せず使い続ける場合、25〜47回目は月5,557円、48回目は5,565円になります。キャンペーンが適用されない機種変更や製品のみ購入では、通常の48回払いは1〜47回目が月2,779円、48回目が2,787円です。</p>
      <p>通信料は使用量に応じて毎月変わります。表には通話料や保証オプション料を含めていません。端末価格は<a href={productUrl} target="_blank" rel="noreferrer">公式商品ページ</a>、通信料は<a href="https://network.mobile.rakuten.co.jp/fee/saikyo-plan/detail/" target="_blank" rel="noreferrer">料金ページ</a>で確認できます。</p>
    </section>

    <section id="device-total">
      <h2>2年で返す場合と、買い切る場合の総額</h2>
      <p>同じiPhone 17e 256GBでも、MNPキャンペーンの有無と返却するかどうかで、端末代の支払い方が変わります。端末の販売価格は133,400円です。</p>
      <Table caption="買い替え超トクプログラムの端末代（税込）" headers={["購入方法", "25カ月目に返却", "返却しない場合", "返却時の別費用"]} rows={[
        ["MNPキャンペーン適用", "24円（1円×24回）", "133,400円（48回）", "3,300円"],
        ["機種変更・製品のみ購入など", "66,696円（2,779円×24回）", "133,400円（48回）", "3,300円"],
      ]} />
      <p>25カ月目以降に端末を返却し、条件を満たすと残りの支払いが不要になります。MNPキャンペーン適用時に25カ月目に返すなら、<strong>端末代24円と返却事務手数料3,300円の合計は3,324円</strong>です。通信料は別にかかります。返却できるのは25〜47カ月目です。</p>
      <p>返さず使い続けるなら、MNPキャンペーン適用時も端末代の総額は133,400円です。「iPhoneが24円で買い切れる」という意味ではありません。一括払い・24回払いも選べますが、月1円の特典は対象の48回払いが条件です。詳しくは<a href="https://network.mobile.rakuten.co.jp/guide/replacement-program/" target="_blank" rel="noreferrer">プログラムの公式案内</a>を確認してください。</p>
    </section>

    <section id="benefits">
      <h2>端末を買うだけでなく、回線も楽天にする理由</h2>
      <h3>データをたくさん使っても通信料は月3,278円</h3>
      <p>データ使い放題の料金を、各社の割引前の月額で比べました。</p>
      <Table caption="大容量プランの割引前月額（税込）" headers={["会社・プラン", "月額", "データ量・速度の注意点"]} rows={[
        ["楽天モバイル Rakuten最強プラン", "3,278円", "混雑時などに速度制御の場合あり"],
        ["au 使い放題MAX＋", "7,788円", "月200GB超で最大5Mbps。テザリングは月60GBまで"],
        ["ソフトバンク テイガク無制限", "8,008円", "直近30日で300GB超の場合は最大4.5Mbps"],
        ["ドコモ MAX", "8,448円", "大量の通信時などに速度制限の場合あり"],
      ]} />
      <p>割引前では楽天モバイルが他社より月4,500円ほど低い金額です。家族割・光回線セット割や付帯サービスは各社で異なるので、今の請求明細と比べてください。</p>
      <p>比較元：<a href="https://network.mobile.rakuten.co.jp/fee/saikyo-plan/detail/" target="_blank" rel="noreferrer">楽天モバイル</a>／<a href="https://www.au.com/mobile/charge/smartphone/plan/data-unlimited-plus/" target="_blank" rel="noreferrer">au</a>／<a href="https://www.softbank.jp/mobile/price_plan/data/teigaku-museigen/" target="_blank" rel="noreferrer">ソフトバンク</a>／<a href="https://www.docomo.ne.jp/charge/docomo_max/" target="_blank" rel="noreferrer">ドコモ</a></p>
      <h3>Rakuten Linkからの対象国内通話は追加月額なし</h3>
      <p>Rakuten Linkアプリから対象の番号へ発信した国内通話は、追加の月額料金なしで利用できます。ドコモ・au・ソフトバンクの国内通話かけ放題オプションは、各社月1,980円です。</p>
      <ul><li>iPhone標準の電話アプリから国内に発信すると、30秒ごとに22円かかります。</li><li>0570から始まる番号や188など、一部の番号は無料通話の対象外です。</li><li>Rakuten Linkを使っていない相手からの電話は、iPhone標準の電話アプリに着信します。</li></ul>
      <p>詳しい対象条件は<a href="https://network.mobile.rakuten.co.jp/service/rakuten-link/" target="_blank" rel="noreferrer">Rakuten Linkの公式案内</a>で確認してください。</p>
      <h3>回線契約の事務手数料は原則無料</h3>
      <p>楽天モバイルの通常の回線契約事務手数料は、同一名義の累計4回線目まで無料です。これは端末を返すときの事務手数料3,300円とは別です。</p>
    </section>

    <section id="cautions">
      <h2>買う前に確認したいこと</h2>
      <h3>電波は、実際に使う場所で確認する</h3>
      <p>電波の入り方や速度は場所によって変わります。地下や建物の中などでは速度が落ちることもあります。申し込む前に<a href="https://network.mobile.rakuten.co.jp/area/" target="_blank" rel="noreferrer">公式エリアマップ</a>で、自宅・職場・通勤経路を確認してください。</p>
      <h3>iPhone 17eはeSIM専用</h3>
      <p>現在のスマホで物理SIMを使っている人も、iPhone 17eではeSIMへの切り替えが必要です。購入画面ではeSIMを選び、移行手順を確認してください。</p>
      <h3>48回払いには本人名義の楽天カードが必要</h3>
      <p>買い替え超トクプログラムで支払いに使えるのは、プログラム契約者本人名義の楽天カードです。家族カードを予定している場合は、申込み前に楽天モバイルへ確認してください。</p>
      <h3>返却時には端末の状態が確認される</h3>
      <p>返却時には事務手数料3,300円がかかります。損傷品と判定された場合は故障費用がかかり、返却できない場合は残りの端末代の支払いが続きます。<a href="https://network.mobile.rakuten.co.jp/guide/replacement-program/loss/" target="_blank" rel="noreferrer">公式の状態基準と費用</a>を確認してください。</p>
    </section>

    <section id="campaign-conditions">
      <h2>月1円の対象は、乗り換えと48回払い</h2>
      <p className="text-sm text-foreground-600">2026年10月5日に公式キャンペーンを再確認。256GBの月1円は1〜24回目に限られ、終了日未定です。</p>
      <p>256GBの月1円特典は、他社から電話番号を引き継いで対象プランを申し込み、同時にiPhone 17eを楽天カードの48回払いで購入する人が対象です。製品とプランをカートに追加すると適用されます。<strong>機種変更・製品のみ購入では月1円になりません。</strong></p>
      <Table caption="iPhone 17e 256GBの主な購入条件" headers={["", "他社から乗り換え", "機種変更・製品のみ購入"]} rows={[
        ["1〜24回目の端末代", "月1円（条件達成時）", "月2,779円（通常の48回払い）"],
        ["25カ月目に返却", "残りの端末代が不要", "残りの端末代が不要"],
        ["返却しない場合", "25回目から支払いが増える", "48回まで端末代を支払う"],
      ]} />
      <p>特典は1人1点・1回までで、過去の解約回線数など対象外条件もあります。ポイント還元やほかのキャンペーンとの組み合わせは一律ではありません。申込み前に<a href={campaignUrl} target="_blank" rel="noreferrer">公式キャンペーンの条件</a>を確認してください。</p>
    </section>

    <section id="apply">
      <h2>自分の使い方に合いそうなら、条件を確認して次へ</h2>
      <p>iPhoneの価格が気になって購入を迷っている人でも、約2年で買い替える予定なら月々の負担を抑えられます。楽天モバイルのエリアと料金が合うか確認してみてください。長く使うつもりなら、月1円ではなく端末総額133,400円で判断しましょう。</p>
      <h3>他社から乗り換える人</h3>
      <ol><li>エリア、楽天カードの名義、eSIMへの移行を確認する。</li><li>月1円特典の対象条件を確認する。</li><li>対象プランのMNP申込みとiPhone 17e 256GBの48回払い購入を同時に進める。</li><li>申込み画面で端末代の1〜24回目が月1円になっているか確かめる。</li></ol>
      <div className="not-prose my-7 grid gap-3 sm:grid-cols-2">
        <a href={campaignUrl} target="_blank" rel="noreferrer" className="rounded-lg border border-[#bf006b] px-5 py-4 text-center font-bold text-[#bf006b] hover:bg-[#fff2f8]">月1円特典の条件を見る ↗</a>
        <a href={affiliateUrl} target="_blank" rel="nofollow sponsored noopener noreferrer" className="rounded-lg bg-[#bf006b] px-5 py-4 text-center font-bold text-white hover:bg-[#9a0057]">楽天モバイルの申込みを確認する［PR］ ↗</a>
      </div>
      <h3>すでに楽天モバイルを使っている人</h3>
      <ol><li>Rakuten Linkアプリ内の「my 楽天モバイル」で今の端末の支払い状況を確認する。</li><li>通常の端末代と返却条件を確認する。</li><li>iPhone 17e 256GBの価格・在庫を確認して購入する。</li></ol>
      <p><a href={productUrl} target="_blank" rel="noreferrer">iPhone 17eの価格・在庫を見る ↗</a> ／ <a href="https://network.mobile.rakuten.co.jp/product/iphone/stock/" target="_blank" rel="noreferrer">在庫・入荷スケジュールを見る ↗</a></p>
      <p>容量・カラーによって配送時期は変わります。購入画面で最新の価格と在庫を確認してください。</p>
      <p><Link to="/articles/rakuten-iphone-18-pro">iPhone 18 Proを買う場合の費用を見る →</Link></p>
    </section>
  </>;
}
